<template>
  <auth-layout>
    <section class="text-center">
      <h1 class="text-2pxl lg:text-2xl font-mulish font-black uppercase">
        {{ APP_NAME }} pension/staff VERIFICATION
      </h1>
      <h5 class="text-sm lg:text-base font-semibold text-oneGray">
        Login to continue
      </h5>
    </section>

    <form @submit.prevent="login">
      <div>
        <label for="emailOrPhone">Username</label>
        <input
          id="emailOrPhone"
          type="text"
          class="input"
          v-model="form.emailOrPhone"
          placeholder="enter email or phone number"
        />
      </div>

      <div class="mt-4">
        <label for="password">Password</label>
        <input
          id="password"
          type="password"
          v-model="form.password"
          class="input"
          placeholder="enter password"
        />
      </div>

      <div class="mt-7">
        <button
          type="submit"
          class="bg-oneGreen text-white rounded-lg py-4 text-sm lg:text-2pxl font-semibold w-full flex justify-center items-center gap-4"
          :disabled="logging || !loginReady"
        >
          <spinner class="" v-if="logging"></spinner>
          <span>Login</span>
        </button>
      </div>
    </form>

    <section
      class="flex flex-col justify-center items-center mt-9 gap-5 text-xs lg:text-sm font-semibold"
    >
      <p class="">
        <router-link
          :to="{
            name: 'Forgot Password',
            query: { nx: 'Login' },
          }"
          class="underline text-blue-500"
        >
          Login using OTP
        </router-link>
        &nbsp;|&nbsp;
        <router-link
          :to="{ name: 'Forgot Password', query: { nx: 'Create Password' } }"
          class="underline text-blue-500"
        >
          Forgot password ?
        </router-link>
      </p>

      <p class="">
        Don't have an account?
        <router-link :to="{ name: 'Signup' }" class="text-oneGreen">
          Register
        </router-link>
      </p>

      <p>
        <router-link
          :to="{
            name: 'Admin Login',
          }"
          class="underline text-blue-500 font-bold"
        >
          Login as Admin
        </router-link>
      </p>
    </section>
  </auth-layout>
</template>

<script>
import AuthLayout from "@/layouts/AuthLayout.vue";

export default {
  name: "Login",

  components: {
    AuthLayout,
  },

  data() {
    return {
      form: {
        emailOrPhone: null,
        password: null,
      },
      logging: false,
    };
  },

  computed: {
    emailOrPhoneReady() {
      return (
        (this.form.emailOrPhone &&
          (/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(this.form.emailOrPhone) ||
            /^(\+[\d]{1,13}|0[\d]{1,11})$/.test(this.form.emailOrPhone))) ||
        !this.form.emailOrPhone
      );
    },
    loginReady() {
      return (
        this.form.emailOrPhone &&
        this.emailOrPhoneReady &&
        this.form.password &&
        this.form.password.length >= 6
      );
    },
  },

  created() {
    this.$store.dispatch("general/logout");
  },

  methods: {
    async login() {
      if (!this.loginReady) {
        this.$swal({
          icon: "error",
          text: "Please fill all input",
        });
        return;
      }

      try {
        this.logging = true;

        const res = await this.$http.post("/employee/login", this.form, {
          headers: { noauth: true },
        });

        if (!res) {
          this.logging = false;
          return;
        }

        const { data } = res;
        this.$store.commit("general/saveUser", {
          user: data.data,
          token: data.token,
        });

        this.$store.commit("general/login");
        this.logging = false;

        if (this.$route.query.nextUrl) {
          this.$router.push(this.$route.query.nextUrl);
          return;
        }

        this.$router.push({ name: "Staff Dashboard" });
      } catch (error) {
        this.logging = false;
      }
    },
  },
};
</script>

<style scoped>
form {
  @apply mx-auto w-full mt-11 lg:mt-14;
  max-width: 35rem;
}
</style>
